import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Layout from 'components/Layout'
import { initializeActiveLocations, listRecentLocations } from 'slices/locationSlice'
import { initializePortfolios } from 'slices/portfolioSlice'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import { ChevronRight as ChevronRightIcon, MapPin as LocationOnIcon, TrendingUp, MapPin, FolderOpen } from 'lucide-react'
import Message from 'components/Message'

function SidebarCommunityAccordian() {
	const dispatch = useDispatch()

	const { portfolios, portfolioSuccess, myRecentPortfolios, portfoliosLoading } = useSelector(
		state => {
			const portfolioIds = state.portfolios.recents
			const myRecentPortfolios = portfolioIds.map(c => state.portfolios.entities[c])
			return {
				portfolios: myRecentPortfolios,
				portfolioSuccess: state.portfolios.isInitialized,
				portfoliosLoading: state.portfolios.isLoading,
			}
		},
	)

	const { locations, isInitialized, recentLocations, isLoading, error } = useSelector(state => {
		// format recent locations based on recent IDs
		const locations = state.locations.entities
		const recentIds = state.locations.recents || []
		const recentLocations = recentIds.map(rId => locations[rId] || {})
		return {
			locations: recentLocations,
			isLoading: state.locations.isLoading,
			isInitialized: state.locations.isInitialized,
			error: state.locations.error,
		}
	})

	useEffect(() => {
		dispatch(initializeActiveLocations())
		// if (!portfolioSuccess) {
		dispatch(initializePortfolios())
		// }
	}, [dispatch, isInitialized, portfolioSuccess])

	const isEmpty = locations.length === 0

	return (
		<Layout>
			<div>
				<Layout.SidebarItem
					title="Recent Activity"
					icon={<TrendingUp className="w-4 h-4" />}
					hasNoMaxHeight
					noPadding
				>
					{locations && locations.length > 0 && (
						<React.Fragment>
							<h5 className="flex items-center gap-1.5 px-4 pt-3 pb-1 text-xs font-semibold text-gray-500 uppercase tracking-wide">
								<MapPin className="w-4 h-4" />
								Locations
							</h5>
							<div>
								{locations.map((location, index) => (
									<Link
										className="flex items-center px-4 py-2 hover:bg-gray-50 no-underline text-inherit"
										key={index}
										to={`/locations/${location._id}`}
									>
										<Avatar className="h-9 w-9 mr-3 shrink-0">
											<AvatarImage src={location.image} />
											<AvatarFallback />
										</Avatar>
										<div className="flex-1 min-w-0">
											<div className="text-sm text-gray-900">{location.assetName}</div>
											{location.updateNote && <div className="text-xs text-gray-500">{location.updateNote}</div>}
										</div>
										<ChevronRightIcon className="w-4 h-4 text-gray-400 shrink-0 ml-2" />
									</Link>
								))}
							</div>
						</React.Fragment>
					)}
					{portfolioSuccess && (
						<React.Fragment>
							<h5 className="flex items-center gap-1.5 px-4 pt-3 pb-1 text-xs font-semibold text-gray-500 uppercase tracking-wide">
								<FolderOpen className="w-4 h-4" /> Portfolios
							</h5>
							<div>
								{portfolios.map((portfolio, index) => (
									<Link
										className="flex items-center px-4 py-2 hover:bg-gray-50 no-underline text-inherit"
										key={index}
										to={`/portfolios/${portfolio._id}`}
									>
										<Avatar className="h-9 w-9 mr-3 shrink-0">
											<AvatarFallback className="bg-amber-50 text-amber-600">{portfolio.assetName?.charAt(0) || 'P'}</AvatarFallback>
											<AvatarFallback />
										</Avatar>
										<div className="flex-1 min-w-0">
											<div className="text-sm text-gray-900">{portfolio.assetName}</div>
											{portfolio.updateNote && <div className="text-xs text-gray-500">{portfolio.updateNote}</div>}
										</div>
										<ChevronRightIcon className="w-4 h-4 text-gray-400 shrink-0 ml-2" />
									</Link>
								))}
							</div>
						</React.Fragment>
					)}
				</Layout.SidebarItem>
			</div>
		</Layout>
	)
}

export default SidebarCommunityAccordian
